'use client';

import React from 'react';
// import '../styles/scss/components/login.scss';
import Link from 'next/link';
import LoginSocial from '../login/LoginSocial';
import RegisterForm from './RegisterForm';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
interface settingsType {
  type: string | null;
  value: string | null;
}
const Login = () => {
  const { data } = useFetcherCSR(`/api/v1/business/settings`);

  const facebookLogin = data?.data?.filter(
    (item: settingsType) => item?.type === 'facebook_login'
  );
  const googleLogin = data?.data?.filter(
    (item: settingsType) => item?.type === 'google_login'
  );
  return (
    <div className="account-pill padding-top padding-bottom">
      <div className="container">
        <div className="account-pill__wrapper">
          <div className="account-pill__filter">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <Link href={'/login'}>
                  <button className="nav-link">Login</button>
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link href={'/register'}>
                  <button className="nav-link active">Register</button>
                </Link>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            <div className="tab-pane fade show active">
              <div className="account__form needs-validation">
                <RegisterForm />
                {!!googleLogin?.[0]?.value && (
                  <LoginSocial
                    src="/images/logo/google.svg"
                    alt="Google"
                    url="/social-login/redirect/google"
                  />
                )}
                {!!facebookLogin?.[0]?.value && (
                  <LoginSocial
                    src="/images/logo/fb.svg"
                    alt="Facebook"
                    url="/social-login/redirect/facebook"
                  />
                )}
                <div className="account-switch text-center mt-3">
                  <p>
                    Already have an account? <Link href="/login">Log in</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
